<div class="section section-dark" id="galeria">
  <div class="container text-center">
    <h2 class="title">Galeria</h2>
    <hr class="section-hr reveal fade-width"/>
    @defer (on viewport; hydrate on viewport) {
      <ngb-carousel role="group" aria-roledescription="carousel" animate.enter="slide-up">
        @for (id of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; track $index) {
          <ng-template ngbSlide>
            <div class="row w-100">
              <div class="col-lg-6">
                <img ngSrc="assets/gallery/galeria{{previousImageId($index, $count)}}.webp"
                     alt="Galeria {{previousImageId($index, $count)}}" class="img-fluid" width="496" height="590">
              </div>
              <div class="col-lg-6">
                <img ngSrc="assets/gallery/galeria{{id}}.webp" alt="Galeria {{id}}" class="img-fluid" width="496"
                     height="590">
              </div>
            </div>
          </ng-template>
        }
      </ngb-carousel>
    } @placeholder (minimum 500ms) {
      <div class="row w-100">
        <div class="col-12 col-lg-6">
          <div class="image-placeholder-container mx-auto">
            <div class="image-placeholder img-fluid"></div>
          </div>
        </div>
        <div class="col-lg-6 d-none d-lg-block">
          <div class="image-placeholder-container mx-auto">
            <div class="image-placeholder img-fluid"></div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
